<template>
	<div>
		<!--불량율 -->
		<sf-card height="330px" :title="getMessage_('QWCC001234')">
			<template v-if="isLoading1">
				<bar-chart :height="280" ref="grpBar" :chartData="datacollection1" :options="optionCollection1" />
			</template>
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcmRegn/store/helpers';

export default {
	components: {
		BarChart: Chart.BarChart
	},
	data() {
		return {};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		datacollection1() {
			return {
				labels: this.stackedLabel_,
				datasets: this.stackedDataSet_
			};
		},
		optionCollection1() {
			//추가
			return {
				//BarChart
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				legend: {
					display: false,
					position: 'bottom' //범례 위치: 아래
				},
				scales: {
					yAxes: [
						{
							ticks: {
								beginAtZero: true,
								suggestedMin: 50,
								suggestedMax: this.chartBcYMaxVal_
							}
						}
					]
				}
			};
		}
	},
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
